import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getDataRequest } from 'utils/request';
import { KEY_DATAPROVIDEAGREESEQ, KEY_DEEPLINKHASH } from 'tools/WebTool';
import FeatherIcon from 'feather-icons-react/build/FeatherIcon';
import StyledActiveButton from 'components/Button/StyledActiveButton';
import ROUTE_PATH from 'routes/config';
import MyPageNavLink from './MyPageNavLink';
import {
  NAV_LIST_MANAGE,
  NAV_LIST_DATA,
  NAV_LIST_LOAN,
  NAV_LIST_GUIDE,
  NOTICE_BANNER_STYLES,
} from './constants';
import {
  NameWrap,
  NameBox,
  MyPageInfoBox,
  MyInfoBox,
  NoticeBannerMsg,
  MyPageMainWrapper,
} from './style';
import { useApp } from 'contexts/AppContext';
import { useUI } from 'contexts/UIContext';
import CustomerFooter from 'components/CustomerFooter';
import Layout from '../../../layout';
import { NavALinkWrap } from './MyPageNavLink/style';
import { JoinDescription, JoinText, LoginDescription, NavLogin } from './style';
import StyledLinkButton from 'components/Button/StyledLinkButton';

const MyPageMain = () => {
  const { auth } = useApp();
  const { setContextLoading } = useUI();
  const navigate = useNavigate();
  const { memberRoleData, memberName } = auth;
  const { mypage, deepLink } = ROUTE_PATH;
  const [newEventYn, setNewEventYn] = useState('');
  const [noticeBannerData, setNoticeBannerData] = useState('');
  const [noticeBannerMsg, setNoticeBannerMsg] = useState('');
  // 대표일 때만 직원 관리 페이지 접근 가능
  const isRepresentative = memberRoleData?.representativeYn === 'Y';
  const HasBusiness = memberRoleData?.businessMappingYn === 'Y';

  useEffect(() => {
    if (auth.authenticated) {
      getDataRequest({
        url: '/v1/au/common/my-page/notice-banner',
        setData: setNoticeBannerData,
        setModalMessage: setNoticeBannerMsg,
        setIsLoading: setContextLoading,
      });
      getDataRequest({
        url: '/v1/na/event/new',
        successFnc: data => {
          setNewEventYn(data?.newEventYn);
        },
      });
    } else {
      setTimeout(() => {
        setContextLoading(false);
      }, 200);
    }
  }, [auth.authenticated]);

  const onClickNoticeBannerHandler = () => {
    switch (noticeBannerData.code) {
      case 'MCR':
        navigate(mypage.manageLoanDataProvide + '?tab=loan');
        break;
      case 'MDU':
        navigate(mypage.manageLoanDataProvide + '?tab=dataUse');
        break;
      case 'MDI':
        navigate(mypage.dataLinkageManage);
        break;
      case 'MLC':
        navigate(mypage.checkLoan);
        break;
      case 'MDA':
        navigate(deepLink.agree);
        localStorage.removeItem(KEY_DEEPLINKHASH);
        localStorage.setItem(
          KEY_DATAPROVIDEAGREESEQ,
          noticeBannerData.dataProvideAgreeSeq
        );
        break;
      case 'MDAA':
        navigate(deepLink.agree + '?type=add-mall');
        break;
    }
  };

  return (
    <Layout pageTitle="마이페이지">
      <MyPageMainWrapper className="mypageMainWrapper">
        <div className="wrapBox">
          {auth.authenticated ? (
            <>
              <MyPageInfoBox>
                <NameWrap>
                  <NameBox>{memberName}</NameBox>님
                </NameWrap>
                <MyInfoBox
                  onClick={() => {
                    navigate(mypage.myInform);
                  }}
                >
                  내 정보
                </MyInfoBox>
              </MyPageInfoBox>
              {HasBusiness && (
                <StyledActiveButton
                  style={NOTICE_BANNER_STYLES}
                  onClick={onClickNoticeBannerHandler}
                >
                  <NoticeBannerMsg>{noticeBannerMsg}</NoticeBannerMsg>
                  <FeatherIcon
                    icon="chevron-right"
                    size={24}
                    strokeWidth={2}
                    stroke="white"
                  />
                </StyledActiveButton>
              )}
              {HasBusiness && (
                <div>
                  {isRepresentative && (
                    <MyPageNavLink
                      title="직원 관리"
                      menuList={NAV_LIST_MANAGE}
                      borderTop="1px solid black"
                    />
                  )}
                  <MyPageNavLink
                    title="데이터 연동"
                    menuList={NAV_LIST_DATA}
                    borderTop={!isRepresentative && '1px solid black'}
                  />
                  <MyPageNavLink title="대출 신청" menuList={NAV_LIST_LOAN} />
                </div>
              )}
            </>
          ) : (
            <>
              <NavALinkWrap
                onClick={() => {
                  navigate(ROUTE_PATH.login.login);
                }}
              >
                <NavLogin tabIndex={0} title="로그인">
                  로그인이 필요해요
                </NavLogin>
                <FeatherIcon
                  style={{ marginTop: '10px' }}
                  icon="chevron-right"
                  size={20}
                  strokeWidth={2}
                  stroke="black"
                />
              </NavALinkWrap>
              <LoginDescription>
                셀러크레딧커넥트에서 <br />
                나에게 맞는 대출을 찾아보세요
              </LoginDescription>
              <StyledLinkButton
                height="80px"
                tabIndex={0}
                onClick={() => {
                  navigate(ROUTE_PATH.login.joinMember);
                }}
              >
                <JoinDescription>아직 회원이 아니신가요?</JoinDescription>
                <JoinText> 회원가입</JoinText>
              </StyledLinkButton>
            </>
          )}

          <MyPageNavLink
            title="안내"
            menuList={NAV_LIST_GUIDE}
            ShowDesc={false}
            hasNewEvent={newEventYn === 'Y'}
          />
        </div>
        <CustomerFooter hasInfo={true} />
      </MyPageMainWrapper>
    </Layout>
  );
};

export default MyPageMain;
